import { Grid, TextField, Typography } from "@mui/material";

import { Producer } from "../types";

interface ProducersComponentTrackersProps {
  producers: Producer[];
  isEditing: boolean;
  // handleProducersChange: (updatedProducers: Producer[]) => void;
  handleProducersTrackers: (updatedProducers: Producer[]) => void;
  setIsEditing: (value: boolean) => void;
}

const ProducersComponetTrackers: React.FC<ProducersComponentTrackersProps> = ({
  producers,
  isEditing,
  handleProducersTrackers,
  // setIsEditing,
  // handleProducersChange,
  // handleSave,
}) => {
  const handleTextProducers = <K extends keyof Producer>(
    index: number,
    field: K,
    value: Producer[K]
  ) => {
    const updatedProducers = [...producers];
    updatedProducers[index][field] = value;

    // Chama a função passada como prop para atualizar os dados no componente pai
    handleProducersTrackers(updatedProducers);

    console.log("Dados Alterados PRODUCERS TRACKERS:", updatedProducers);
  };

  return (
    <>
      {producers.map((producer, index) => (
        <Grid container item key={index} spacing={2}>
          <Grid
            item
            xs={6}
            textAlign={"start"}
            sx={{
              paddingX: "20px",
              marginTop: "30px",
            }}
          >
            <Typography sx={{ marginBottom: "8px" }}>
              Fabricante {index + 1}
            </Typography>
          </Grid>

          <Grid container spacing={2} sx={{ padding: "20px" }}>
            {isEditing ? (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Telefone de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactPhone}
                    onChange={(e) =>
                      handleTextProducers(index, "contactPhone", e.target.value)
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Email de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactEmail}
                    onChange={(e) =>
                      handleTextProducers(index, "contactEmail", e.target.value)
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Link de Acesso ao Portal - ${index + 1}`}
                    variant="outlined"
                    value={producer.portalAccessLink}
                    onChange={(e) =>
                      handleTextProducers(
                        index,
                        "portalAccessLink",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Usuário de Acesso ao Portal - ${index + 1}`}
                    variant="outlined"
                    value={producer.portalAccessUsername}
                    onChange={(e) =>
                      handleTextProducers(
                        index,
                        "portalAccessUsername",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label={`Senha de Acesso ao Portal - ${index + 1}`}
                    variant="outlined"
                    value={producer.portalAccessPassword}
                    onChange={(e) =>
                      handleTextProducers(
                        index,
                        "portalAccessPassword",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Telefone de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactPhone}
                    onChange={(e) =>
                      handleTextProducers(index, "contactPhone", e.target.value)
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Email de Contato - ${index + 1}`}
                    variant="outlined"
                    value={producer.contactEmail}
                    onChange={(e) =>
                      handleTextProducers(index, "contactEmail", e.target.value)
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Link de Acesso ao Portal - ${index + 1}`}
                    variant="outlined"
                    value={producer.portalAccessLink}
                    onChange={(e) =>
                      handleTextProducers(
                        index,
                        "portalAccessLink",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Usuário de Acesso ao Portal - ${index + 1}`}
                    variant="outlined"
                    value={producer.portalAccessUsername}
                    onChange={(e) =>
                      handleTextProducers(
                        index,
                        "portalAccessUsername",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    disabled
                    size="small"
                    label={`Senha de Acesso ao Portal - ${index + 1}`}
                    variant="outlined"
                    value={producer.portalAccessPassword}
                    onChange={(e) =>
                      handleTextProducers(
                        index,
                        "portalAccessPassword",
                        e.target.value
                      )
                    }
                    style={{ fontSize: 16 }}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} md={3}>
              {/* <Button type="submit" onClick={handleSaveAndExitEditMode}>
                Salvar Dados
              </Button> */}
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );
};
export default ProducersComponetTrackers;
